import React from "react";
import Routes from "../Routes";
import { Link, withRouter } from "react-router-dom";
import { withUser } from "../Contexts/user";
import { FcUndo } from "react-icons/fc";

const Sidebar = withRouter(({ user, location }) => {
    if (user.auth.userId === null) {
        window.location.href = "/login";
    }
    return (
        <div className="min-h-screen text-white min-w-48 w-2/12 flex-shrink-0 hidden lg:block">
            <div className="hidden lg:block sidebar h-full px-8 py-4">
                <div className="flex justify-start py-2 items-center">
                    <div className="relative z-10 p-2 overflow-hidden rounded-lg flex justify-start items-center">
                        <div className="relative">
                            <img
                                src="https://ik.imagekit.io/dnddecpho/dndream/D&D_SystemIcons-39_VVsmT445q.png?updatedAt=1744725564154"
                                alt="Main Content"
                                className="w-full h-full object-contain"
                            />
                        </div>
                    </div>
                </div>

                {Routes.map(({ Icon, ...route }, i) => {
                    if (route.hidden) return null;
                    if (route.sdpath && user?.auth?.director !== "SD") return null;

                    if (user?.auth?.ranking) {
                        if (route.primepath && user.auth.ranking.name !== "prime leader") return null;
                        if (route.pdpath && user.auth.director !== "PD") return null;
                        if (route.sdpath && user.auth.director !== "SD") return null;
                        if (route.coordinatorpath && user.auth.director !== "coordinator") return null;
                    }

                    return (
                        <Link
                            className={`flex font-semibold ${
                                location.pathname === route.path
                                    ? "text-orange-400 font-black underline"
                                    : "text-cool-gray"
                            } hover:underline underline-offset p-2 items-center`}
                            key={i}
                            to={route.path}
                        >
                            <div className="mr-2">
                                <Icon />
                            </div>
                            <div className="text-sm" style={{ fontSize: '22vt', fontFamily: 'Poppins, sans-serif', fontWeight: 'normal' }}>
                                {route.name}
                            </div>
                        </Link>
                    );
                })}
                <div
                    onClick={user.auth.logout}
                    className="cursor-pointer text-sm flex hover:underline underline-offset p-2 items-center font-semibold"
                >
                    <FcUndo className="mr-2" /> Logout
                </div>
            </div>
        </div>
    );
});

export default withUser(Sidebar);
